<template>
    <section class="qualification section">
        <h2 class="section__title">Qualification</h2>
        <span class="section__subtitle">My Personal Journey</span>

        <div class="qualification__container container">
            <div class="qualification__tabs">
                <div 
                    class="qualification__button button--flex" 
                    :class="{ 'qualification__active': activeTab === 'education' }"
                    @click="activeTab = 'education'"
                >
                    <i class="uil uil-graduation-cap qualification__icon"></i>
                    Education
                </div>
                <div 
                    class="qualification__button button--flex" 
                    :class="{ 'qualification__active': activeTab === 'work' }"
                    @click="activeTab = 'work'"
                >
                    <i class="uil uil-briefcase-alt qualification__icon"></i>
                    Work
                </div>
            </div>

            <div class="qualification__sections">

                <!-- ===== EDUCATION (Semua Konten di KIRI, Garis di KANAN) ===== -->
                <div 
                    class="qualification__content" 
                    :class="{ 'qualification__active': activeTab === 'education' }"
                    id="education"
                >
                    <div class="timeline-column timeline-column--left-align">

                        <!-- Item 1 -->
                        <div class="timeline-column__item">
                            <div class="timeline-column__body">
                                <h3 class="qualification__title">Informatics Engineering</h3>
                                <span class="qualification__subtitle">Hamka - University</span>
                                <div class="qualification__calender">
                                    <i class="uil uil-calender-alt"></i> Sep 2022 - Aug 2026
                                </div>
                            </div>
                            <div class="timeline-column__marker">
                                <span class="timeline-column__dot"></span>
                                <span class="timeline-column__line"></span>
                            </div>
                        </div>

                        <!-- Item 2 -->
                        <div class="timeline-column__item">
                            <div class="timeline-column__body">
                                <h3 class="qualification__title">Bangkit Academy</h3>
                                <span class="qualification__subtitle">Study Program - Dicoding</span>
                                <div class="qualification__calender">
                                    <i class="uil uil-calender-alt"></i> Sep 2024 - Jan 2025
                                </div>
                            </div>
                            <div class="timeline-column__marker">
                                <span class="timeline-column__dot"></span>
                                <span class="timeline-column__line"></span>
                            </div>
                        </div>

                        <!-- Item 3 -->
                        <div class="timeline-column__item">
                            <div class="timeline-column__body">
                                <h3 class="qualification__title">Samsung Innovation Campus</h3>
                                <span class="qualification__subtitle">Bootcamp - Skilvul</span>
                                <div class="qualification__calender">
                                    <i class="uil uil-calender-alt"></i> 2024
                                </div>
                            </div>
                            <div class="timeline-column__marker">
                                <span class="timeline-column__dot"></span>
                                <span class="timeline-column__line"></span>
                            </div>
                        </div>

                        <!-- Item 4 -->
                        <div class="timeline-column__item">
                            <div class="timeline-column__body">
                                <h3 class="qualification__title">Data Science Explorers</h3>
                                <span class="qualification__subtitle">Bootcamp - Asean Foundation</span>
                                <div class="qualification__calender">
                                    <i class="uil uil-calender-alt"></i> 2023
                                </div>
                            </div>
                            <div class="timeline-column__marker">
                                <span class="timeline-column__dot"></span>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- ===== WORK (Semua Konten di KANAN, Garis di KIRI) ===== -->
                <div 
                    class="qualification__content" 
                    :class="{ 'qualification__active': activeTab === 'work' }"
                    id="work"
                >
                    <div class="timeline-column timeline-column--right-align">

                        <!-- Item 1 -->
                        <div class="timeline-column__item">
                            <div class="timeline-column__marker">
                                <span class="timeline-column__dot"></span>
                                <span class="timeline-column__line"></span>
                            </div>
                            <div class="timeline-column__body">
                                <h3 class="qualification__title">Founder & Developer</h3>
                                <span class="qualification__subtitle">Affidev - Jakarta</span>
                                <div class="qualification__calender">
                                    <i class="uil uil-calender-alt"></i> Jun 2024 - Present
                                </div>
                            </div>
                        </div>

                        <!-- Item 2 -->
                        <div class="timeline-column__item">
                            <div class="timeline-column__marker">
                                <span class="timeline-column__dot"></span>
                            </div>
                            <div class="timeline-column__body">
                                <h3 class="qualification__title">Web Developer</h3>
                                <span class="qualification__subtitle">PKM Uhamka - Jakarta</span>
                                <div class="qualification__calender">
                                    <i class="uil uil-calender-alt"></i> Oct 2024 - Jul 2025
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Qualification',
    data() {
        return {
            activeTab: 'education'
        }
    }
}
</script>
